var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.93 20.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_720"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_8241",
    d: "M14.98,20.93H5.96c-3.29,0-5.95-2.67-5.96-5.96V5.96C0,2.67,2.67,0,5.96,0h9.02c3.29,0,5.95,2.67,5.96,5.96v9.02c0,3.29-2.67,5.95-5.96,5.95M5.96,1.79c-2.3,0-4.16,1.87-4.16,4.16v9.02c0,2.3,1.87,4.16,4.16,4.16h9.02c2.3,0,4.16-1.87,4.16-4.16V5.96c0-2.3-1.87-4.16-4.16-4.16H5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8242",
    d: "M10.47,15.83c-2.96,0-5.36-2.4-5.36-5.36,0-2.96,2.4-5.36,5.36-5.36,2.96,0,5.36,2.4,5.36,5.36,0,2.96-2.4,5.36-5.36,5.36M10.47,6.9c-1.97,0-3.57,1.6-3.57,3.56s1.6,3.57,3.56,3.57,3.57-1.6,3.57-3.56h0c0-1.97-1.6-3.56-3.56-3.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8243",
    d: "M17.34,4.8c0,.71-.58,1.29-1.29,1.29s-1.29-.58-1.29-1.29.58-1.29,1.29-1.29,1.29.58,1.29,1.29h0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.7a90c30ea75a785fb7e75adca388054e.svg";
export { ForwardRef as ReactComponent };